/* 
 * 接口统一集成模块
 */
import * as user from './modules/user'
import * as account from './modules/account'
import * as selftrain from './modules/selftrain'
import * as netdisk from './modules/netdisk'
import * as saving from './modules/saving'

// 默认全部导出
export default {
    user,
    account,
    selftrain,
    netdisk,
    saving,
}